// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"ai-chart-bar"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M15 12H19V21H15V12Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M7 6H11V21H7V6Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21H3V3M15 12H19V21H15V12ZM7 6H11V21H7V6Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.25 3L19.7697 4.23028L21 4.75L19.7697 5.26972L19.25 6.5L18.7303 5.26972L17.5 4.75L18.7303 4.23028L19.25 3Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-ai-chart-bar')
export default class AiChartBarIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-chart-bar',
    }
  }
}
